<app-modal-frame
  [headerText]="CONSTS.DO_NOT_PROCESS_HEADER"
  [hasHeaderCloseButton]="false"
  [rightButton]="{
    text: CONSTS.OK,
    type: BUTTON_TYPES.TEXT_BUTTON,
  }"
  (emitRightClick)="onClose()"
>
  <ion-grid class="container">
    <ion-row class="body large-text">
      <ion-col>
        {{ CONSTS.DO_NOT_PROCESS_BODY }}
      </ion-col>
    </ion-row>
    <ion-row class="body">
      <ion-col>
        {{ CONSTS.DO_NOT_PROCESS_BODY_2 }}
      </ion-col>
    </ion-row>
    <div class="number-container">
      <ul class="body">
        @for (number of dialogRef.trackingNumberList; track number) {
          <li>
            {{ number }}
          </li>
        }
      </ul>
    </div>
  </ion-grid>
</app-modal-frame>
